export default __webpack_public_path__ + "static/media/shampoo.e7dc678a.jpg";